import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Dropdown } from 'floating-vue';
import { useBreakpoint } from '~/composables';

interface Props {
  marker?: any;
  distance?: string | number;
  placement?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiMarkerPoint',
  props: {
    marker: { default: () => ({}) },
    distance: { default: 16 },
    placement: { default: 'left' }
  },
  setup(__props: any) {

const props = __props as { marker: any, distance: string | number, placement: string };



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

// @TODO: Simplify after deploying to master and changing json format of block at homepage
const markerPosition = computed(() =>
  !props.marker.position.desktop
    ? props.marker.position
    : (!isDesktop.value && props.marker.position.mobile) ||
      props.marker.position.desktop,
);

return { __sfc: true,props, isDesktop, markerPosition, Dropdown }
}

})